import { verifiedSymbol } from "./core.js";
export const alwaysTrue = (t)=>{
  t[verifiedSymbol] = true;
  return true;
};
//# sourceMappingURL=helpers.js.map